import { useSearchParams } from "react-router-dom";
import { ArticleCard } from "../components/site/Cards";
import { PageHero, FilterChips } from "./Katalog";
import { CATEGORIES, useGet } from "../lib/api";

export default function Edukasi() {
  const [params, setParams] = useSearchParams();
  const kategori = params.get("kategori") || "";
  const { data, isLoading } = useGet("articles", "/articles", { category: kategori || undefined });
  const [first, ...rest] = data || [];
  return (
    <>
      <PageHero eyebrow="Pojok Edukasi" title="Belajar Seputar Sapi & Peternakan" desc="Tips peternakan, pengetahuan tentang sapi, dan fakta-fakta unik yang menarik untuk disimak." />
      <section className="mx-auto max-w-7xl px-5 py-14 lg:px-8">
        <FilterChips
          options={[["", "Semua"], ...CATEGORIES.map((c) => [c.slug, c.label])]}
          value={kategori}
          onChange={(v) => setParams(v ? { kategori: v } : {})}
          prefix="category-tab"
        />
        {isLoading ? (
          <p className="mt-10 text-[var(--ink)]/60">Memuat artikel...</p>
        ) : !first ? (
          <p className="mt-10 text-[var(--ink)]/60" data-testid="articles-empty">Belum ada artikel di kategori ini.</p>
        ) : (
          <div className="mt-10 space-y-8" data-testid="articles-list">
            <ArticleCard a={first} large />
            <div className="grid gap-7 sm:grid-cols-2 lg:grid-cols-3">
              {rest.map((a) => <ArticleCard key={a.id} a={a} />)}
            </div>
          </div>
        )}
      </section>
    </>
  );
}
